import { styledByTheme } from "../../../../themes/architecture/styled-by-theme";
import { ProfileCashierButtonCasino777Box } from "./profile-cashier-button.casino777.box";
import { ProfileCashierButtonCasino888Box } from "./profile-cashier-button.casino888.box";
import { ProfileCashierButtonDefaultBox } from "./profile-cashier-button.default.box";
import { ProfileCashierButtonWsopBox } from "./profile-cashier-button.wsop.box";
import {ProfileCashierButtonHarrahsBox} from "./profile-cashier-button.harrahs.box";
import {ProfileCashierButtonMrGreenBox} from "./profile-cashier-button.mrgreen.box";

export const ProfileCashierButtonBox = styledByTheme(ProfileCashierButtonDefaultBox)
    .forCasino777(ProfileCashierButtonCasino777Box)
    .forCasino888(ProfileCashierButtonCasino888Box)
    .forHarrahs(ProfileCashierButtonHarrahsBox)
    .forWsop(ProfileCashierButtonWsopBox)
    .forMrGreen(ProfileCashierButtonMrGreenBox)
    .apply();
